import { render, staticRenderFns } from "./modalVendaPdv.vue?vue&type=template&id=264a1867&scoped=true&"
import script from "./modalVendaPdv.vue?vue&type=script&lang=js&"
export * from "./modalVendaPdv.vue?vue&type=script&lang=js&"
import style0 from "./modalVendaPdv.vue?vue&type=style&index=0&id=264a1867&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264a1867",
  null
  
)

export default component.exports